import React, { FC, useState, useEffect } from "react";
import { ArrowRightIcon } from "@heroicons/react/outline";
import LocationMarker from "components/AnyReactComponent/LocationMarker";
import CommentListing from "components/CommentListing/CommentListing";
import FiveStartIconForRate from "components/FiveStartIconForRate/FiveStartIconForRate";
import { DateRage } from "components/HeroSearchForm/StaySearchForm";
import StartRating from "components/StartRating/StartRating";
import GoogleMapReact from "google-map-react";
import useWindowSize from "hooks/useWindowResize";
import moment from "moment";
import { DayPickerRangeController, FocusedInputShape } from "react-dates";
import Avatar from "shared/Avatar/Avatar";
import Badge from "shared/Badge/Badge";
import ButtonCircle from "shared/Button/ButtonCircle";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Input from "shared/Input/Input";
import NcImage from "shared/NcImage/NcImage";
import LikeSaveBtns from "./LikeSaveBtns";
import ModalPhotos from "./ModalPhotos";
import { Helmet } from "react-helmet";

import BackgroundSection from "components/BackgroundSection/BackgroundSection";
// import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import carUtilities1 from "images/carUtilities/1.png";
import carUtilities2 from "images/carUtilities/2.png";
import carUtilities3 from "images/carUtilities/3.png";
import carUtilities4 from "images/carUtilities/4.png";
import carUtilities5 from "images/carUtilities/5.png";
import carUtilities6 from "images/carUtilities/6.png";
import carUtilities7 from "images/carUtilities/7.png";
import carUtilities8 from "images/carUtilities/8.png";
// import RentalCarDatesRangeInput from "components/HeroSearchForm/RentalCarDatesRangeInput";
import { TimeRage } from "components/HeroSearchForm/RentalCarSearchForm";
import { IInput, IReviews } from "types/interfaces";
import SectionSliderRecommendation from "components/SectionSliderRecommendation/SectionSliderRecommendation";
// import { addOrder } from "actions/orderActions";
// import { addCart } from "actions/cartActions";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import Error from "shared/Error";
import toRupiah from "utils/toRupiah";
import {
  getSingleProduct,
  likedProduct,
  reviewProduct,
} from "actions/productActions";
import { Link } from "react-router-dom";
import DOMPurify from "dompurify";
import Loading from "shared/Loading";
import ButtonTop from "shared/Button/ButtonTop";
import { eventAnalytic } from "hooks/useAnalytics";
import logging from "utils/logging";

export interface ListingCarDetailPageProps {
  className?: string;
  match?: any;
  price?: number;
  history?: any;
}

const includes_demo = [
  { name: "Gratis pembatalan sampai dengan 48 jam sebelum pengambilan" },
  { name: "Pengurangan biaya tanggung jawab kerusakan hingga $214" },
  { name: "Perlindungan anti maling lebih dari $19,999" },
  { name: "Jarak tempuh tanpa batas" },
  {
    name: "Interior dan eksterior mobil dibersihkan dengan disinfektan sebelum pengambilan",
  },
  { name: "Wajib memakai masker di lokasi pengambilan" },
];

const Amenities_demos = [
  { name: "59 MPG Combined, 58 City/60 Hwy", icon: carUtilities1 },
  {
    name: "Forward Collision-Avoidance Assist with Pedestrian Detection (FCA-Ped)",
    icon: carUtilities2,
  },
  { name: "139-hp gas/electric combined", icon: carUtilities3 },
  { name: "Proximity Key with push button start", icon: carUtilities4 },
  { name: "8-inch color touchscreen display audio", icon: carUtilities5 },
  { name: "Smart Cruise Control with Stop & Go (SCC)", icon: carUtilities6 },
  { name: "LED Daytime Running Lights (DRL)", icon: carUtilities7 },
  { name: "Blind-Spot Collision Warning (BCW)", icon: carUtilities8 },
];

export interface IRating {
  stars: number;
  message: string;
}

const ListingCarDetailPage: FC<ListingCarDetailPageProps> = ({
  className = "",
  match,
  price = 100000,
  history,
}) => {
  const { singleProduct: thing } = useSelector(
    (state: RootState) => state.productSingle
  );

  useEffect(() => {
    dispatch(getSingleProduct(match.params.id));
  }, [match.params.id]);

  // Check user login atau engga
  const { userInfo } = useSelector((state: RootState) => state.userInfo);
  const { loading, error } = useSelector(
    (state: RootState) => state.ongoingOrder
  );
  const { likedProducts } = useSelector(
    (state: RootState) => state.likedProduct
  );

  const {
    loading: reviewLoading,
    error: reviewError,
    review,
  } = useSelector((state: RootState) => state.productReview);

  useEffect(() => {
    if (review && review._id) thing.status.reviews.unshift(review);
  }, [review]);

  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [openFocusIndex, setOpenFocusIndex] = useState(0);
  const [rating, setRating] = useState<IRating>({ stars: 5, message: "" });

  const [pickUpLocation, setPickUpLocation] = useState<IInput>({
    value: "Bandara Ngurah Rai",
    warning: "",
  });
  const [dropOffLocation, setDropOffLocation] = useState<IInput>({
    value: "Pantai Kuta",
    warning: "",
  });

  const [dateRangeValue, setDateRangeValue] = useState<DateRage>({
    startDate: moment().startOf("day"),
    endDate: moment().startOf("day").add(1, "days"),
  });
  const [timeRangeValue, setTimeRangeValue] = useState<TimeRage>({
    startTime: "10:00",
    endTime: "10:00",
  });

  // ngitungin berapa lama durasi sewa
  // const date1 = moment(dateRangeValue.endDate).startOf("day");
  // const date2 = moment(dateRangeValue.startDate).startOf("day");
  // const diffDate = date1.diff(date2, "hours");
  // const time1 = moment(timeRangeValue.endTime, "hh:mm");
  // const time2 = moment(timeRangeValue.startTime, "hh:mm");
  // const diffTime = time1.diff(time2, "hour");
  // const different = Math.ceil((diffDate + diffTime) / 24);

  const [focusedInputSectionCheckDate, setFocusedInputSectionCheckDate] =
    useState<FocusedInputShape>("startDate");

  // const handleRent = () => {
  //   if (userInfo) {
  //     if (thing.profile.phone) {
  //       window.open(`https://wa.me/62${thing.profile.phone}`, "_blank");
  //     } else {
  //       window.open("https://wa.me/6285161514605", "_blank");
  //     }
  //   } else {
  //     history.push("/login");
  //   }
  // };

  // const handleCart = () => {
  //   dispatch(addCart(match.params.id, different));
  // };

  const windowSize = useWindowSize();

  const getDaySize = () => {
    if (windowSize.width <= 375) {
      return 34;
    }
    if (windowSize.width <= 500) {
      return undefined;
    }
    if (windowSize.width <= 1280) {
      return 56;
    }
    return 48;
  };

  const handleOpenModal = (index: number) => {
    setIsOpen(true);
    setOpenFocusIndex(index);
  };

  const handleCloseModal = () => setIsOpen(false);
  const handleLike = () => {
    dispatch(likedProduct(thing._id));
  };

  const handleRating = () => {
    dispatch(reviewProduct(rating, thing._id));
  };

  const renderSection1 = () => {
    return (
      <div className="listingSection__wrap !space-y-6">
        {/* 1 */}
        <div className="flex justify-between items-center">
          {thing.category ? (
            <Badge color="pink" name={thing.category} />
          ) : (
            <div
              className={`text-2xl sm:text-3xl lg:text-4xl font-semibold ${
                thing.category ||
                "h-4 w-14 animate-pulse bg-gray-300 bg-opacity-50 rounded-md"
              }`}
            />
          )}

          <LikeSaveBtns
            liked={
              likedProducts &&
              likedProducts.find((value: string) => {
                return value === thing._id;
              })
                ? true
                : false
            }
            onClick={handleLike}
          />
        </div>

        {/* 2 */}
        <div
          className={`text-2xl sm:text-3xl lg:text-4xl font-semibold ${
            thing.name ||
            "h-8 w-36 animate-pulse bg-gray-300 bg-opacity-50 rounded-md"
          }`}
        >
          {thing.name}
        </div>

        {/* 3 */}
        <div className="flex items-center space-x-4">
          <StartRating
            reviewCount={thing.status.reviews.length}
            point={thing.status.rating}
          />
          <span>·</span>

          <div
            className={`${
              thing.address.kecamatan.name ||
              "h-5 w-10 animate-pulse bg-gray-300 bg-opacity-50 rounded-md"
            }`}
          >
            {thing.address.kecamatan.name && (
              <i className="las la-map-marker-alt"></i>
            )}
            <span className="ml-1">
              {" "}
              {`${thing.address.kecamatan.name} / ${thing.address.kabupaten.name}` ||
                ""}
            </span>
          </div>
        </div>

        {/* 4 */}
        <Link to={thing.profile.href || "/"} className="flex items-center">
          <Avatar
            hasChecked={thing.profile.verified}
            sizeClass="h-10 w-10"
            radius="rounded-full"
            imgUrl={thing.profile.avatar}
          />
          <div className="ml-2.5 text-neutral-500 dark:text-neutral-400 flex">
            <span>Pemilik barang</span>
            <div
              className={`text-neutral-900 dark:text-neutral-200 font-medium ml-1 ${
                thing.profile.displayName ||
                "h-5 w-10 animate-pulse bg-gray-300 bg-opacity-50 rounded-md"
              }`}
            >
              <span>{thing.profile.displayName}</span>
            </div>
          </div>
        </Link>

        {/* 5 */}
        {/* <div className="w-full border-b border-neutral-100 dark:border-neutral-700" /> */}

        {/* 6 */}
        {/* <div className="flex items-center justify-between xl:justify-start space-x-8 xl:space-x-12 text-sm text-neutral-700 dark:text-neutral-300">
          <div className="flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 text-center sm:text-left sm:space-x-3 ">
            <i className="las la-user-friends text-2xl"></i>
            <span className="">4 tempat duduk</span>
          </div>
          <div className="flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 text-center sm:text-left sm:space-x-3 ">
            <i className="las la-dharmachakra text-2xl"></i>
            <span className=""> Transmisi Otomatis</span>
          </div>
          <div className="flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 text-center sm:text-left sm:space-x-3 ">
            <i className="las la-gas-pump text-2xl"></i>
            <span className=""> Pertamax</span>
          </div>
        </div> */}
      </div>
    );
  };

  // eslint-disable-next-line
  const renderSectionTienIch = () => {
    return (
      <div className="listingSection__wrap">
        <div>
          <h2 className="text-2xl font-semibold">Spesifikasi </h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            Bertanya adalah inti dari menuju kesuksesan.
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* 6 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-6 gap-x-10 text-sm text-neutral-700 dark:text-neutral-300 ">
          {/* TIEN ICH 1 */}
          {Amenities_demos.map((item, index) => (
            <div key={index} className="flex items-center space-x-4 ">
              <div className="w-10 flex-shrink-0">
                <img src={item.icon} alt="" />
              </div>
              <span>{item.name}</span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderSection2 = () => {
    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl font-semibold">Deskripsi</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="text-neutral-6000 dark:text-neutral-300">
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(
                thing.description || "Produk tidak memiliki Deskripsi"
              ).replaceAll("\n", "<br />"),
            }}
          ></div>
        </div>
      </div>
    );
  };

  // eslint-disable-next-line
  const renderSection3 = () => {
    return (
      <div className="listingSection__wrap">
        <div>
          <h2 className="text-2xl font-semibold">Sudah Termasuk</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            Sudah termasuk dengan harga
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* 6 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 text-sm text-neutral-700 dark:text-neutral-300 ">
          {includes_demo
            .filter((_, i) => i < 12)
            .map((item) => (
              <div key={item.name} className="flex items-center space-x-3">
                <i className="las la-check-circle text-2xl"></i>
                <span>{item.name}</span>
              </div>
            ))}
        </div>
      </div>
    );
  };
  // eslint-disable-next-line
  const renderSectionCheckIndate = () => {
    return (
      <div className="listingSection__wrap overflow-hidden">
        {/* HEADING */}
        <div>
          <h2 className="text-2xl font-semibold">Ketersediaan</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            Harga mungkin akan naik pada akhir pekan/hari libur
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* CONTENT */}
        <div className="listingSection__wrap__DayPickerRangeController flow-root">
          <div className="-mx-4 sm:mx-auto xl:mx-[-22px]">
            <DayPickerRangeController
              startDate={dateRangeValue.startDate}
              endDate={dateRangeValue.endDate}
              onDatesChange={(date) => setDateRangeValue(date)}
              focusedInput={focusedInputSectionCheckDate}
              onFocusChange={(focusedInput) =>
                setFocusedInputSectionCheckDate(focusedInput || "startDate")
              }
              initialVisibleMonth={null}
              numberOfMonths={windowSize.width < 1280 ? 1 : 2}
              daySize={getDaySize()}
              hideKeyboardShortcutsPanel
            />
          </div>
        </div>

        {/*  */}
        <div className="flex space-x-8">
          <div className="w-1/2 space-y-2">
            <label className="font-medium" htmlFor="startTime">
              Waktu pengambilan :
            </label>
            <Input
              defaultValue={timeRangeValue.startTime}
              rounded="rounded-xl"
              id="startTime"
              type="time"
              onChange={(e) => {
                setTimeRangeValue({
                  startTime: e.target.value,
                  endTime: timeRangeValue.endTime,
                });
              }}
            />
          </div>
          <div className="w-1/2 space-y-2">
            <label className="font-medium" htmlFor="endTime">
              Waktu pengembalian :
            </label>
            <Input
              defaultValue={timeRangeValue.endTime}
              rounded="rounded-xl"
              id="endTime"
              type="time"
              onChange={(e) =>
                setTimeRangeValue({
                  startTime: timeRangeValue.startTime,
                  endTime: e.target.value,
                })
              }
            />
          </div>
        </div>
      </div>
    );
  };

  const renderSection5 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <h2 className="text-2xl font-semibold">Pemilik Barang</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

        {/* host */}
        <Link
          to={thing.profile.href || "/"}
          className="flex items-center space-x-4"
        >
          <Avatar
            hasChecked={thing.profile.verified}
            hasCheckedClass="w-4 h-4 -top-0.5 right-0.5"
            sizeClass="h-14 w-14"
            radius="rounded-full"
            imgUrl={thing.profile.avatar}
          />
          <div>
            <span className="block text-xl font-medium">
              {thing.profile.displayName}
            </span>
            <div className="mt-1.5 flex items-center text-sm text-neutral-500 dark:text-neutral-400">
              <StartRating />
            </div>
          </div>
        </Link>

        {/* desc */}
        <span className="block text-neutral-6000 dark:text-neutral-300">
          {thing.profile.description}
        </span>

        {/* info */}
        <div className="block text-neutral-500 dark:text-neutral-400 space-y-2.5">
          <div className="flex items-center space-x-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <span>
              Bergabung sejak {moment(thing.profile.createdAt).format("ll")}
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
              />
            </svg>
            <span>Persentase Respon - 100%</span>
          </div>
          <div className="flex items-center space-x-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>

            <span>Kecepatan Respon - dalam beberapa jam</span>
          </div>
        </div>

        {/* == */}
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div>
          <ButtonSecondary href={thing.profile.href || "/"}>
            Kunjungi Profil
          </ButtonSecondary>
        </div>
      </div>
    );
  };

  const renderSection6 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <h2 className="text-2xl font-semibold">
          Ulasan ({thing.status.reviews.length})
        </h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

        {/* Content */}
        <div className="space-y-5">
          <FiveStartIconForRate
            iconClass="w-6 h-6"
            className="space-x-0.5"
            defaultPoint={rating.stars}
            onRate={(e) => setRating({ ...rating, stars: e })}
          />
          <div className="relative">
            <Input
              fontClass=""
              sizeClass="h-16 px-4 py-3"
              rounded="rounded-3xl"
              placeholder="Berikan pendapat anda ..."
              onChange={(e) => {
                setRating({ ...rating, message: e.target.value });
              }}
            />
            <ButtonCircle
              className="absolute right-2 top-1/2 transform -translate-y-1/2"
              size=" w-12 h-12 "
              onClick={handleRating}
            >
              {reviewLoading ? (
                <Loading center={true} />
              ) : (
                <ArrowRightIcon className="w-5 h-5" />
              )}
            </ButtonCircle>
          </div>
        </div>

        {/* comment */}
        <div className="divide-y divide-neutral-100 dark:divide-neutral-800">
          {thing.status.reviews.length > 0 &&
            thing.status.reviews.map((review: IReviews, index: number) => {
              return (
                <CommentListing
                  className="py-8"
                  data={review}
                  key={review._id}
                />
              );
            })}
          <div className="pt-8">
            <ButtonSecondary>
              Tampilkan Semua Ulasan ({thing.status.reviews.length})
            </ButtonSecondary>
          </div>
        </div>
      </div>
    );
  };

  const renderSection7 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <div>
          <h2 className="text-2xl font-semibold">Lokasi</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            {thing.address.kecamatan.name} / {thing.address.kabupaten.name}
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

        {/* MAP */}
        <div className="aspect-w-5 aspect-h-5 sm:aspect-h-3">
          <div
            className={`rounded-xl overflow-hidden ${
              thing.address.map?.latitude ||
              "animate-pulse bg-gray-300 bg-opacity-50"
            }`}
          >
            <GoogleMapReact
              bootstrapURLKeys={{
                key: "AIzaSyAYuFE0a7MCk8Xxd-EYY-ps-mpW_oTQCnU",
              }}
              defaultZoom={15}
              yesIWantToUseGoogleMapApiInternals
              center={{
                lat: thing.address.map?.latitude || 0,
                lng: thing.address.map?.longitude || 0,
              }}
              defaultCenter={{
                lat: -8.746181688205855,
                lng: 115.16865381448561,
              }}
            >
              <LocationMarker
                lat={thing.address.map?.latitude || 0}
                lng={thing.address.map?.longitude || 0}
              />
            </GoogleMapReact>
          </div>
        </div>
      </div>
    );
  };

  const renderSection8 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <h2 className="text-2xl font-semibold">Syarat dan Ketentuan Vendor</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

        {/* CONTENT */}
        <div>
          <p
            className="block mt-3 text-neutral-500 dark:text-neutral-400 text"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(
                thing.tnc || "Tidak ada syarat dan ketentuan khusus"
              ).replaceAll("\n", "<br>"),
            }}
          >
            {/* {`${thing.tnc}lol` || "Tidak ada syarat dan ketentuan khusus"} */}
          </p>
        </div>
      </div>
    );
  };

  const renderSidebarPrice = () => {
    return (
      <div className="listingSection__wrap shadow-xl">
        {/* PRICE */}
        <div className="flex justify-between">
          <span className="text-3xl font-semibold">
            Rp {toRupiah(thing.price)}
            <span className="ml-1 text-base font-normal text-neutral-500 dark:text-neutral-400">
              /hari
            </span>
          </span>
          <StartRating
            reviewCount={thing.status.reviews.length}
            point={thing.status.rating}
          />
        </div>

        {/* FORM */}
        {/* <form className="flex border  border-neutral-200 dark:border-neutral-700 rounded-3xl ">
          <RentalCarDatesRangeInput
            defaultDateValue={dateRangeValue}
            defaultTimeValue={timeRangeValue}
            pickUpLocation={pickUpLocation.value}
            dropOffLocation={dropOffLocation.value}
            onFocusChange={() => {}}
            numberOfMonths={1}
            fieldClassName="p-5"
            wrapFieldClassName="flex flex-col w-full flex-shrink-0 relative divide-y divide-neutral-200 dark:divide-neutral-700"
            onChange={(data) => {
              setDateRangeValue(data.stateDate);
              setTimeRangeValue(data.stateTimeRage);
            }}
            onTimeChange={(e) => setTimeRangeValue(e)}
            anchorDirection={windowSize.width > 1400 ? "left" : "right"}
          />
        </form> */}

        {/* SUM */}
        {/* <div className="flex flex-col space-y-4 ">
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>
              Rp {toRupiah(thing.price)} x {different} hari
            </span>
            <span>Rp. {toRupiah(thing.price * different)}</span>
          </div>

          {thing.status.saleOff > 0 && (
            <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
              <span>Diskon {thing.status.saleOff} %</span>
              <span>
                Rp. {toRupiah((thing.price * thing.status.saleOff) / 100)}
              </span>
            </div>
          )}

          <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
          <div className="flex justify-between font-semibold">
            <span>Total</span>
            <span>
              Rp.{" "}
              {toRupiah(
                thing.price * different -
                  (thing.price * thing.status.saleOff) / 100
              )}
            </span>
          </div>
        </div> */}
        {/* SUBMIT */}
        <div className="flex flex-col space-y-3">
          {/* <ButtonSecondary
            className="inline-flex items-center"
            type="button"
            onClick={handleCart}
          >
            <i className="las la-cart-plus text-2xl mr-1"></i>
            <span>Masukkan ke Keranjang</span>
          </ButtonSecondary> */}
          <a
            className="ttnc-ButtonPrimary disabled:bg-opacity-70 bg-primary-6000 dark:bg-primary-6000  hover:bg-primary-700 text-neutral-50 nc-Button relative h-auto inline-flex items-center justify-center rounded-full transition-colors dark:text-neutral-200 px-4 py-3 sm:px-6 text-sm sm:text-base font-medium"
            type="button"
            target={"_blank"}
            onClick={() => {
              logging(userInfo?.token || "", {
                category: "product",
                action: "chat",
                target: thing.id || thing._id,
              });
              eventAnalytic({
                category: "Product",
                action: `Chat vendor`,
                label: `${thing.profile.userId}`,
              });
            }}
            rel="noreferrer"
            href={
              userInfo
                ? thing.address.phone
                  ? `https://wa.me/62${
                      thing.address.phone
                    }?text=${encodeURIComponent(
                      `Halo ${thing.profile.displayName}, apakah *${thing.name}* tersedia untuk disewa?\n\nLink barang: https://rentrips.id/listing/${thing._id}`
                    )}`
                  : "https://wa.me/6285161514605"
                : `/login?redirect=${window.location.pathname}`
            }
          >
            Hubungi Vendor
          </a>
        </div>
      </div>
    );
  };

  //eslint-disable-next-line
  const renderSidebarDetail = () => {
    return (
      <div className="listingSection__wrap shadow-xl">
        <span className="text-2xl font-semibold block">
          Pengambilan dan Pengembalian
        </span>
        <div className="mt-8 flex">
          <div className="flex-shrink-0 flex flex-col items-center py-2">
            <span className="block w-6 h-6 rounded-full border border-neutral-400"></span>
            <span className="block flex-grow border-l border-neutral-400 border-dashed my-1"></span>
            <span className="block w-6 h-6 rounded-full border border-neutral-400"></span>
          </div>
          <div className="ml-4 space-y-14 text-sm">
            <div className="flex flex-col space-y-2">
              <span className=" text-neutral-500 dark:text-neutral-400">
                Senin, 12 Agustus · 10:00
              </span>
              <Input
                className="font-bold text-lg ring-0 ring-offset-0 border-0 border-b-2 rounded-none"
                value={pickUpLocation.value}
                type="text"
                onChange={(e) =>
                  setPickUpLocation({ value: e.target.value, warning: "" })
                }
              ></Input>
            </div>
            <div className="flex flex-col space-y-2">
              <span className=" text-neutral-500 dark:text-neutral-400">
                Senin, 16 Agustus · 10:00
              </span>
              <Input
                className="font-bold text-lg ring-0 ring-offset-0 border-0 border-b-2 rounded-none"
                value={dropOffLocation.value}
                type="text"
                onChange={(e) =>
                  setDropOffLocation({ value: e.target.value, warning: "" })
                }
              ></Input>{" "}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`nc-ListingCarDetailPage  ${className}`}
      data-nc-id="ListingCarDetailPage"
    >
      <Helmet>
        <title>
          Sewa {thing.name || "Barang"} Terbaik dan Terlengkap | Rentrips.id
        </title>
        <meta
          name="title"
          content={`Sewa ${thing.name || "Barang"} Terbaik dan Terlengkap | Rentrips.id`}
        ></meta>
        <meta
          name="description"
          content={`Sewa ${thing.name || "barang"} terbaik dan termurah.  ${
            thing.description || ""
          } `}
        />
        <link rel="image_src" href={thing.images[0] || ""}></link>
        <meta property="og:site_name" content="Rentrips.id"></meta>
      </Helmet>
      {error && <Error>Gagal dalam menyewa barang</Error>}
      {/* SINGLE HEADER */}
      <>
        <header className="container 2xl:px-14 rounded-md sm:rounded-xl">
          <div className="relative grid grid-flow-col grid-cols-4  gap-1 sm:gap-2">
            <div
              className={`${
                thing.images.length > 1
                  ? "col-span-2 row-span-2"
                  : "col-span-4 row-span-2 h-96"
              } relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer`}
              onClick={() => handleOpenModal(0)}
            >
              <NcImage
                containerClassName="inset-0"
                className="object-cover w-full h-full rounded-md sm:rounded-xl"
                src={thing.images[0]}
                prevImageHorizontal
              />
              <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
            </div>

            {/* 2nd picture */}
            <div
              className={`${
                thing.images.length === 2
                  ? "col-span-2 row-span-2"
                  : thing.images.length === 3 || thing.images.length === 4
                  ? "col-span-2 row-span-1"
                  : thing.images.length === 5
                  ? "col-span-1 row-span-1"
                  : "hidden"
              } relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer`}
              onClick={() => handleOpenModal(1)}
            >
              <NcImage
                containerClassName="absolute inset-0"
                className="object-cover w-full h-full rounded-md sm:rounded-xl"
                src={thing.images[1]}
                prevImageHorizontal
              />
              <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
            </div>

            {/** 3rd picture */}
            <div
              className={`${
                thing.images.length === 3
                  ? "col-span-2 row-span-1"
                  : thing.images.length === 4 || thing.images.length === 5
                  ? "col-span-1 row-span-1"
                  : "hidden"
              } relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer`}
              onClick={() => handleOpenModal(2)}
            >
              <NcImage
                containerClassName="absolute inset-0"
                className="object-cover w-full h-full rounded-md sm:rounded-xl"
                src={thing.images[2]}
                prevImageHorizontal
              />
              <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
            </div>
            {/** 4rd picture */}
            <div
              className={`${
                thing.images.length >= 4 ? "col-span-1 row-span-1" : "hidden"
              } relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer`}
              onClick={() => handleOpenModal(3)}
            >
              <NcImage
                containerClassName="absolute inset-0"
                className="object-cover w-full h-full rounded-md sm:rounded-xl"
                src={thing.images[3]}
                prevImageHorizontal
              />
              <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
            </div>
            {/** 5rd picture */}
            <div
              className={`${
                thing.images.length === 5 ? "col-span-1 row-span-1" : "hidden"
              } relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer`}
              onClick={() => handleOpenModal(4)}
            >
              <NcImage
                containerClassName="absolute inset-0"
                className="object-cover w-full h-full rounded-md sm:rounded-xl"
                src={thing.images[4]}
                prevImageHorizontal
              />
              <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
            </div>

            <div
              className="absolute hidden md:flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-neutral-100 text-neutral-500 cursor-pointer hover:bg-neutral-200 z-10"
              onClick={() => handleOpenModal(0)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                />
              </svg>
              <span className="ml-2 text-neutral-800 text-sm font-medium">
                Show all photos
              </span>
            </div>
          </div>
        </header>
        {/* MODAL PHOTOS */}
        <ModalPhotos
          imgs={thing.images}
          isOpen={isOpen}
          onClose={handleCloseModal}
          initFocus={openFocusIndex}
        />
      </>

      {/* MAIn */}
      <main className="container mt-11 flex ">
        {/* CONTENT */}
        <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:pr-10 lg:space-y-10">
          {renderSection1()}
          {/* <div className="block lg:hidden">{renderSidebarDetail()}</div> */}
          {/* {renderSectionTienIch()} */}
          {renderSection2()}
          {/* {renderSection3()} */}
          {/* <div className="block sm:hidden">{renderSectionCheckIndate()}</div> */}
          {renderSection7()}
          {renderSection8()}
          {renderSection5()}
          {reviewError && <Error>{reviewError}</Error>}
          {renderSection6()}
        </div>

        {/* SIDEBAR */}
        <div className="hidden lg:block flex-grow">
          {/* {renderSidebarDetail()} */}
          <div className="sticky top-24">{renderSidebarPrice()}</div>
        </div>
      </main>

      {/* STICKY FOOTER MOBILE */}
      <div className="block lg:hidden fixed bottom-0 inset-x-0 py-4 bg-white text-neutral-900 border-t border-neutral-200 z-20">
        <div className="container flex items-center justify-between">
          <span className="text-2xl font-semibold">
            Rp. {toRupiah(thing.price)}
            <span className="ml-1 text-base font-normal text-neutral-500 dark:text-neutral-400">
              /hari
            </span>
          </span>
          <div className="flex items-center">
            {/* <ButtonSecondary className="mr-3 rounded-full">
              {" "}
              <i className="las la-cart-plus text-lg"></i>
            </ButtonSecondary> */}
            <a
              className="ttnc-ButtonPrimary disabled:bg-opacity-70 bg-primary-6000 dark:bg-primary-6000  hover:bg-primary-700 text-neutral-50 nc-Button relative h-auto inline-flex items-center justify-center rounded-full transition-colors dark:text-neutral-200 px-4 py-3 sm:px-6 text-sm sm:text-base font-medium"
              type="button"
              onClick={() => {
                eventAnalytic({
                  category: "Product",
                  action: `Chat vendor`,
                  label: `${thing.profile.userId}`,
                });
                logging(userInfo?.token || "", {
                  category: "product",
                  action: "chat",
                  target: thing.id || thing._id,
                });
              }}
              target={"_blank"}
              rel="noreferrer"
              href={
                userInfo
                  ? thing.address.phone
                    ? `https://wa.me/62${
                        thing.address.phone
                      }?text=${encodeURIComponent(
                        `Halo ${thing.profile.displayName}, apakah *${thing.name}* tersedia untuk disewa?\n\nLink barang: https://rentrips.id/listing/${thing._id}`
                      )}`
                    : "https://wa.me/6285161514605"
                  : "/login"
              }
            >
              {loading ? "...loading" : "Hubungi Vendor"}
            </a>
          </div>
        </div>
      </div>

      {/* OTHER SECTION */}
      <div className="container py-24 lg:py-32">
        {/* SECTION 1 */}
        <div className="relative py-16">
          <BackgroundSection />
          {/* <SectionSliderNewCategories
            heading="Barang-barang serupa lainnya"
            subHeading="Barang yang kemungkinan besar akan anda suka"
            categoryCardType="card6"
            itemPerRow={5}
            sliderStyle="style2"
          /> */}
          <SectionSliderRecommendation
            heading="Barang-barang serupa lainnya"
            subHeading="Barang yang kemungkinan besar akan anda suka"
            itemPerRow={4}
            sliderStyle="style2"
            category={thing.category}
            current={thing._id}
          />
        </div>
        <ButtonTop />
        {/* SECTION */}
        {/* <SectionSubscribe2 className="pt-24 lg:pt-32" /> */}
      </div>
    </div>
  );
};

export default ListingCarDetailPage;
